import styled from 'styled-components'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { bp } from 'lib/core/resources/helpers/styled'

export const Header = styled(FlexWrapper)`
  justify-content: center;
`

export const ArrowContainer = styled(FlexWrapper)<any>`
  justify-content: space-between;
  position: absolute;
  top: 45%;
  right: 0;
  left: 0;
  z-index: 4;
  pointer-events: none;
  ${props => props.isPromo && `
    top: 0;
    bottom: 0;
    left: 10px;
    right: 10px;
  `}

  button {
    background-color: transparent;
    border: 0 none;
    display: flex;
    align-items: center;
    pointer-events: all;

    &:focus {
      outline: none;
    }
  }

  svg {
    width: 15px;
    height: auto;
    fill: ${props => props.isPromo ? props.theme.palette.general.white : props.theme.palette.primary.gammaLight};
  }

  .progress {
    position: absolute;
    top: calc(50% - 10px);
    right: 30px;

    > svg {
      width: 20px;
      height: 20px;
    }
  }
`

export const Container = styled.div<any>`
  position: relative;
  ${props => props.isPromo && `
    z-index: -1;
  `}

  .carousel {
    overflow: ${props => props.fadeSides ? 'initial' : 'hidden'};

    &__slider {
      ${props => props.fadeSides && `
        overflow: initial;
      `}
    }

    &__dot-group {
      display: flex;
      justify-content: center;
      z-index: 2;
      position: absolute;
      left: 0;
      right: 0;

      .carousel__dot {
        border: 1px solid ${props => props.theme.palette.general.grey};
        width: ${props => props.fadeSides ? '50px' : '15px'};
        height: ${props => props.fadeSides ? '5px' : '15px'};
        border-radius: ${props => props.fadeSides ? '20px' : '100%'};
        margin: 0 5px;

        &--selected {
          background: ${props => props.fadeSides ? props.theme.palette.general.strong : props.theme.palette.general.greyLight};
          border-color: ${props => props.fadeSides ? props.theme.palette.general.strong : props.theme.palette.general.greyLight};
        }
      }
    }

    &__slide {
      ${props => props.fadeSides && `
        opacity: 0.4;
        
        &--visible {
          opacity: 1;
        }
      `}
    }
  }
`

export const Arrow = styled.div<ArrowProps>`
  border-color: ${props => props.theme.palette.general.greyDark};
  border-style: solid;
  width: 30px;
  height: 30px;
  transform: rotate(45deg);
  border-width: ${props => props.isNext ? '2px 2px 0 0' : '0 0 2px 2px'};
  cursor: pointer;
  transition: 0.2s;
  ${bp('sm')`
    display: none;
  `}

  &:hover {
    transform: scale(1.1) rotate(45deg);
  }

  &:active {
    transform: scale(0.5) rotate(45deg);
  }
`

interface ArrowProps {
  isNext?: boolean
}
